import React from 'react';
import { Skeleton } from '@material-ui/lab';
import { Grid } from '@material-ui/core';
import Header from 'components/Header';
import styles from './SkeletonForm.module.scss';

const SkeletonForm = (): JSX.Element => (
  <Grid container>
    <Header
      title={(
        <Skeleton>
          <span className={styles.text}>Sign In</span>
        </Skeleton>
      )}
      directions={(
        <Skeleton>
          <span className={styles.text}>
            Please enter your email address or username and password to log into your account.
          </span>
        </Skeleton>
      )}
    />
    <div className={styles.label}>
      <Skeleton>
        <span className={styles.text}>Email Address or Username</span>
      </Skeleton>
    </div>
    <div className={styles.input}>
      <Skeleton className={styles.skeleton} />
    </div>
    <div className={styles.label}>
      <Skeleton>
        <span className={styles.text}>Password</span>
      </Skeleton>
    </div>
    <div className={styles.input}>
      <Skeleton className={styles.skeleton} />
    </div>
    <div className={styles.footer}>
      <Skeleton className={styles.skeleton} />
    </div>
  </Grid>
);

export default SkeletonForm;
